import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, Spinner, Row, Col } from 'react-bootstrap';

//Components
import Clipboardurlevento from './clipboardurlevento';
import StatusCredenciamento from './StatusCredenciamento';

//Utils
import { getEvento } from '../../../../utils/eventosession';
import { getUserGeren } from '../../../../utils/authusuariogerenciamento';

const Header  = (props) => {

    const user = getUserGeren();
    const [evento, onEvento] = useState(false);

    useEffect(() => {
        
        const eventosession = getEvento();
        let eventoatual = {};

        if(props.eventoselecionado && props.eventoselecionado.idevento){
            eventoatual = props.eventoselecionado;
        }else if(eventosession && eventosession.idevento){
            eventoatual = eventosession;
        }

        if(evento === false){
            onEvento(eventoatual);
        }else if(eventoatual.idevento && eventoatual.idevento !== evento.idevento){
            onEvento(eventoatual);
        }
    },[props.eventoselecionado, evento]);
    
    return (        
        <Card style={{ 
            marginLeft: '68px', 
            marginTop: "1%",
            maxWidth: "100%", 
            marginRight: "5px", 
            overflow: "hidden",
            zIndex: 100,
            position: 'sticky',
            top: 0 }}>
            <Card.Body>
                <Card.Title>{props.titulo}</Card.Title>
                <Row>
                    <Col><Card.Subtitle className="mb-2 text-muted border-1">{props.subtitulo}</Card.Subtitle></Col>
                    <Col className="text-right">
                    {props.pendingTasks?
                    <Spinner animation="border" />
                    :
                    null
                    }
                    </Col>
                </Row>
                <hr />
                {evento&&evento.idevento?<StatusCredenciamento idevento={evento.idevento} idpromotora={evento.idpromotora} />:null}
                <Card.Title className="text-success">
                    {evento&&evento.idevento?`${evento.sigladoevento} ${evento.edicao}`:'Selecione um Evento'}                        
                </Card.Title>                
                <Card.Subtitle className="mb-2 text-muted"><small>{user&&user.id?`Bem vindo(a), ${user.name}`:''}</small></Card.Subtitle>
                <small>
                    {props.descricao}                    
                </small>
                {evento&&evento.idevento?<Clipboardurlevento evento={{...evento}} />:null}                
            </Card.Body>
        </Card>
    )   
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks,
        eventoselecionado: state.reducerEventoSelecionado
    }
}

export default connect(mapStateToProps)(withRouter(Header));